var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Loading',{attrs:{"visible":_vm.isLoading}}),_c('data-open-header',{attrs:{"title":"文档资料","active":"file-data"}}),_c('Main'),_c('data-open-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }